/* eslint-disable @typescript-eslint/no-explicit-any */

export function objForEach(obj: any, iterator: (key: any, value: any) => void): void {
  if (!obj) {
    return;
  }
  Object.keys(obj).forEach((dataKey) => {
    iterator(dataKey, obj[dataKey]);
  });
}

export function objProperty(obj: any, propName?: string | string[]): any {
  let result = obj;
  if (Array.isArray(propName)) {
    propName.forEach((name) => {
      if (result) {
        result = result[name];
      }
    });
  } else if (propName) {
    result = result[propName];
  }
  return result;
}

export function objEquals(obj1: any, obj2: any, ignoreKeys: string[] = []): boolean {
  if (!obj1 && !obj2) return true;
  if (!!obj1 !== !!obj2) return false;
  return Object.keys(obj1).every((key) => ignoreKeys.includes(key) || obj1[key] === obj2[key]);
}

export function removeObjectProperty(obj: unknown, propertyName: string) {
  if (typeof obj == "object" && obj !== null) {
    const casted = obj as Record<string, unknown>;
    if (Object.prototype.hasOwnProperty.call(casted, propertyName)) {
      delete casted[propertyName];
    }
  }
}
